<script setup>
import { ref } from 'vue'
import ModalBox from './ModalBox.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const props = defineProps({
	videoid: {
		type: String,
		required: true,
	},
	modalId: {
		type: String,
		default: 'modal-demo-video',
	},
})

const active = ref(false)

const { isVisible, show, hide } = useLegacyModalBridge(
	() => props.modalId,
	{
		onShow: () => { active.value = true },
		onHide: () => { active.value = false },
		onHidden: () => { active.value = false },
	},
)

const getPlayerUrl = () => {
	if (!active.value) return undefined
	return `https://app.supademo.com/embed/${props.videoid}`
}

defineExpose({ show, hide, dismiss: hide })
</script>

<template>
	<ModalBox
		v-model="isVisible"
		size="lg"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none p-0 overflow-hidden"
	>
		<div
			class="demo_container"
			style="position: relative; padding-bottom: calc(49.051932838734864% + 44px); height: 0;"
		>
			<iframe
				v-if="active"
				:src="getPlayerUrl()"
				frameborder="0"
				webkitallowfullscreen="true"
				mozallowfullscreen="true"
				allowfullscreen
				style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
			/>
		</div>
	</ModalBox>
</template>

<style scoped>
@media only screen and (max-width: 600px) {
	.demo_container {
		padding-bottom: calc(49%) !important;
	}
}
</style>
